import "core-js/modules/es.string.link.js";
import styled from "styled-components";
import { Box, Link } from "@pochta/ui";
export var HeaderBox = styled(Box).withConfig({
  displayName: "Headerstyles__HeaderBox",
  componentId: "sc-1rbx3hp-0"
})(["position:relative;box-sizing:border-box;font-family:", ";*,::after,::before{box-sizing:border-box;}"], function (_ref) {
  var theme = _ref.theme,
      modernFonts = _ref.modernFonts;
  return modernFonts ? theme.font.fontFamily : "inherit";
});
export var BorderedBox = styled(Box).withConfig({
  displayName: "Headerstyles__BorderedBox",
  componentId: "sc-1rbx3hp-1"
})(["box-shadow:inset 0px -1px 0px rgba(0,0,0,0.05);"]);
export var HeaderContainer = styled(Box).withConfig({
  displayName: "Headerstyles__HeaderContainer",
  componentId: "sc-1rbx3hp-2"
})(["height:110px;", "{height:56px;}position:relative;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.notDesktop;
});
export var HeaderTop = styled.div.withConfig({
  displayName: "Headerstyles__HeaderTop",
  componentId: "sc-1rbx3hp-3"
})(["display:flex;height:", ";"], function (_ref3) {
  var notDesktop = _ref3.notDesktop;
  return "".concat(notDesktop ? 56 : 48, "px");
});
export var HeaderTopInner = styled.div.withConfig({
  displayName: "Headerstyles__HeaderTopInner",
  componentId: "sc-1rbx3hp-4"
})(["display:flex;flex:1 0;align-items:center;"]);
export var HeaderTab = styled(Link).withConfig({
  displayName: "Headerstyles__HeaderTab",
  componentId: "sc-1rbx3hp-5"
})(["&&&{font-family:inherit;color:", ";border-bottom-color:", ";transition:none;&:visited{color:", ";border-bottom-color:", ";}&:hover,&:focus{color:", ";border-bottom-color:", ";}}"], function (_ref4) {
  var text = _ref4.theme.color.text,
      _ref4$activeTab = _ref4.activeTab,
      activeTab = _ref4$activeTab === void 0 ? false : _ref4$activeTab;
  return activeTab ? text.link.base : text.black.base;
}, function (_ref5) {
  var activeTab = _ref5.activeTab,
      theme = _ref5.theme;
  return activeTab ? theme.color.text.link.base : "transparent";
}, function (_ref6) {
  var text = _ref6.theme.color.text,
      _ref6$activeTab = _ref6.activeTab,
      activeTab = _ref6$activeTab === void 0 ? false : _ref6$activeTab;
  return activeTab ? text.link.base : text.black.base;
}, function (_ref7) {
  var activeTab = _ref7.activeTab,
      theme = _ref7.theme;
  return activeTab ? theme.color.text.link.base : "transparent";
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.color.text.link.hover;
}, function (_ref9) {
  var activeTab = _ref9.activeTab,
      theme = _ref9.theme;
  return activeTab ? theme.color.text.link.hover : "transparent";
});
export var IconWrapper = styled(Box).withConfig({
  displayName: "Headerstyles__IconWrapper",
  componentId: "sc-1rbx3hp-6"
})(["position:relative;top:", ";display:flex;align-items:center;"], function (_ref10) {
  var _ref10$modernColors = _ref10.modernColors,
      modernColors = _ref10$modernColors === void 0 ? false : _ref10$modernColors;
  return modernColors ? "0" : "-1px";
});
export var IconBoltWrapper = styled(Box).withConfig({
  displayName: "Headerstyles__IconBoltWrapper",
  componentId: "sc-1rbx3hp-7"
})(["display:flex;align-items:center;position:relative;top:", ";"], function (_ref11) {
  var _ref11$modernColors = _ref11.modernColors,
      modernColors = _ref11$modernColors === void 0 ? false : _ref11$modernColors;
  return modernColors ? "0" : "-1px";
});
export var IconMobileBoltWrapper = styled(Box).withConfig({
  displayName: "Headerstyles__IconMobileBoltWrapper",
  componentId: "sc-1rbx3hp-8"
})(["position:relative;top:-1px;"]);
export var UserNameContainer = styled(Box).withConfig({
  displayName: "Headerstyles__UserNameContainer",
  componentId: "sc-1rbx3hp-9"
})(["overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"]);
export var TooltipUserWrapper = styled(Box).withConfig({
  displayName: "Headerstyles__TooltipUserWrapper",
  componentId: "sc-1rbx3hp-10"
})(["text-align:left;& > div{padding:5px 0;}"]);
export var ServiceMenuTarget = styled(Box).withConfig({
  displayName: "Headerstyles__ServiceMenuTarget",
  componentId: "sc-1rbx3hp-11"
})(["&:empty{display:none;}"]);